module.exports = __webpack_public_path__ + "media/images/forms-icons/date-time-icon-004c7a9d05a7498c3c71985da32923ac.svg";